import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { Simplebar } from "../Simplebar/Simplebar";
import useMessage from "../../Hooks/useMessage";

const ReportesViewer = ({ reporte, setShowCanvas, showCanvas }) => {
    const { cerrarAlertas } = useMessage();

    useEffect(() => {
        return () => {
            cerrarAlertas();
        };
    }, []);

    return (
        <Simplebar
            size="xxxl"
            backdrop={true}
            placement={"end"}
            portal={false}
            visible={showCanvas}
            setShow={(e) => {
                setShowCanvas(e);
            }}
            useLoading={true}
            title="Reporte"
            btnLeft={{
                show: true,
                message: "Abrir en nueva pestaña",
                isComponent: true,
                size: "45px",
                height: "24px",
                with: "24px",
                iconName: "link",
                func: () => {
                    if (reporte?.Url) {
                        window.open(reporte.Url, "_blank");
                    }
                },
            }}
            btnRight={{
                show: false,
                label: "Grabar",
                func: () => {},
            }}
        >
            <Row
                style={{
                    minHeight: "100vh",
                    maxHeight: "100vh",
                    padding: 0,
                    margin: 0,
                    width: "100%",
                }}
            >
                <Col
                    md={12}
                    style={{
                        padding: 0,
                        margin: 0,
                    }}
                >
                    {reporte?.Url && (
                        <iframe src={reporte.Url} width="100%" height="100%" />
                    )}
                </Col>
            </Row>
        </Simplebar>
    );
};
export default ReportesViewer;